import React, { useState, useEffect } from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Banner from './Banner';
import Required from './Required';
import Needlessly from './Needlessly';
import Media from './Media';
import FormInfo from './FormInfo';
import FormSubmit from './FormSubmit';
import { submitFormHandleHK2024, getHostHandleHK2024, updateFormHandleHK2024 } from '@src/services/api';
import { Toast, SpinLoading } from 'antd-mobile';
import Confirm from './Confirm';
import Success from './Success';
import { getlocal, setlocal, getStringLenth } from '@src/utils/index';
import SecondShare from './secondShare';
import { zhanden } from '@src/utils/zhanden'; 

let checkRequiredSucess = false;

const Layout = () => {
    // 提交数据加载态
    const [languages, setLanguages] = useState(() => getlocal('languages') || 'zh');
    // 提交数据加载态
    const [isShowLoading, setIsShowLoading] = useState(false);
    // 是否勾选知晓信息
    const [understand, setUnderstand] = useState(false);
     // 获取更新id
    const [updateId, setUpdateId] = useState(() => getlocal('_id'));
    const [updateSuccess, setUpdateSuccess] = useState(false);
    // 是否提交
    const [isClickSubmit, setIsClickSubmit] = useState(false);
    // 确认弹窗
    const [confirmData, setConfirmData] = useState({
        isClickOk: false,
        isCheck: false,
        isClosePopup: true,
    });
    // 提交成功弹窗
    const [hasSucessPopup, setHasSucessPopup] = useState(false);
    // 必选项
    const [formData, setFormData] = useState({
        name: '',
        gender: '',
        age: '',
        education_level: '',
        country_or_region: '',
        documents: '',
        familiar_chinese: '',
        contact_details: '',
        img1: '',
        img2: '',
        video_self: '',
        video_production: '',
        self_introduction: '',
        current_occupation: '',
        current_city: '',
        other_platforms: '',
    });
    const [warningTextList, setWarningTextList] = useState({
        name: {
            value: '',
            isScrollTop: false,
        },
        gender: {
            value: '',
            isScrollTop: false,
        },
        age: {
            value: '',
            isScrollTop: false,
        },
        education_level: {
            value: '',
            isScrollTop: false,
        },
        country_or_region: {
            value: '',
            isScrollTop: false,
        },
        documents: {
            value: '',
            isScrollTop: false,
        },
        familiar_chinese: {
            value: '',
            isScrollTop: false,
        },
        contact_details: {
            value: '',
            isScrollTop: false,
        },
        img: {
            value: '',
            isScrollTop: false,
        },
        video_self: {
            value: '',
            isScrollTop: false,
        },
        video_production: {
            value: '',
            isScrollTop: false,
        },
        self_introduction: {
            value: '',
            isScrollTop: false,
        },
        current_occupation: {
            value: '',
            isScrollTop: false,
        },
        current_city: {
            value: '',
            isScrollTop: false,
        },
        other_platforms: {
            value: '',
            isScrollTop: false,
        }
    });

    // 校验表单
    const checkFormDataHandle = () => {
        const dataOrder = [
            'name',
            'gender',
            'age',
            'education_level',
            'country_or_region',
            'documents',
            'familiar_chinese',
            'contact_details',
            'img1',
            'img2',
            'video_self',
            'video_production',
            'self_introduction',
            'current_occupation',
            'current_city',
            'other_platforms',
        ];
        const warningTextListNew = warningTextList;
        const name = formData['name'];
        const gender = formData['gender'];
        const age = formData['age'];
        const education_level = formData['education_level'];
        const country_or_region = formData['country_or_region'];
        const documents = formData['documents'];
        const familiar_chinese = formData['familiar_chinese'];
        const contact_details = formData['contact_details'];
        const img1 = formData['img1'];
        const img2 = formData['img2'];
        const video_self = formData['video_self'];
        const video_production = formData['video_production'];
        const self_introduction = formData['self_introduction'];
        const current_occupation = formData['current_occupation'];
        const current_city = formData['current_city'];
        const other_platforms = formData['other_platforms'];

        // console.log(languages, 'languages')

        // 姓名
        if (name === '') {
            warningTextListNew['name']['value'] = zhanden[languages].name.waring1;
        } else if (getStringLenth(name) > 100) {
            warningTextListNew['name']['value'] = zhanden[languages].name.waring2;
        } else {
            warningTextListNew['name']['value'] = '';
        }
        // 性别
        if (gender === '') {
            warningTextListNew['gender']['value'] = zhanden[languages].gender.waring1;
        } else {
            warningTextListNew['gender']['value'] = '';
        }
        // 年龄
        if (age === '') {
            warningTextListNew['age']['value'] = zhanden[languages].age.waring1;
        } else if (age !== '' && !Number(age) && Number(age).toString().length !== getStringLenth(age)) {
            warningTextListNew['age']['value'] = zhanden[languages].age.waring2;
        } else if (age !== '' && getStringLenth(age) > 2) {
            warningTextListNew['age']['value'] = zhanden[languages].age.waring3;
        } else {
            warningTextListNew['age']['value'] = '';
        }
        // 教育程度
        if (education_level === '') {
            warningTextListNew['education_level']['value'] = zhanden[languages].education.waring1;
        } else if (education_level !== '' && getStringLenth(education_level) > 100) {
            warningTextListNew['education_level']['value'] = zhanden[languages].education.waring2;
        } else {
            warningTextListNew['education_level']['value'] = '';
        }
        // 国家或地区
        if (country_or_region === '') {
            warningTextListNew['country_or_region']['value'] = zhanden[languages].country.waring1;
        } else if (getStringLenth(country_or_region) > 100) {
            warningTextListNew['country_or_region']['value'] = zhanden[languages].country.waring2;
        } else {
            warningTextListNew['country_or_region']['value'] = '';
        }
        // 所持证件
        if (documents === '') {
            warningTextListNew['documents']['value'] = zhanden[languages].documents.waring1;
        } else if (getStringLenth(country_or_region) > 100) {
            warningTextListNew['documents']['value'] = zhanden[languages].documents.waring2;
        } else {
            warningTextListNew['documents']['value'] = '';
        }
        // 是否熟悉中文
        if (familiar_chinese === '') {
            warningTextListNew['familiar_chinese']['value'] = zhanden[languages].hasChinese.waring1;
        } else {
            warningTextListNew['familiar_chinese']['value'] = '';
        }
        // 联系方式
        if (contact_details === '') {
            warningTextListNew['contact_details']['value'] = zhanden[languages].contact.waring1;
        } else if (getStringLenth(contact_details) > 100) {
            warningTextListNew['contact_details']['value'] = zhanden[languages].contact.waring2;
        } else {
            warningTextListNew['contact_details']['value'] = '';
        }
         // 照片
         if (img1 === '' || img2 === '') {
            warningTextListNew['img']['value'] = zhanden[languages].photo.waring3;
        } else {
            warningTextListNew['img']['value'] = '';
        }

        // 自我介绍视频
        if (video_self === '') {
            warningTextListNew['video_self']['value'] = zhanden[languages].videoSelf.waring2;
        } else {
            warningTextListNew['video_self']['value'] = '';
        }
        // 视频作品
        if (video_production === '') {
            warningTextListNew['video_production']['value'] = zhanden[languages].videoProduct.waring2;
        } else {
            warningTextListNew['video_production']['value'] = '';
        }
        // 介绍一下自己
        if (self_introduction !== '' && getStringLenth(self_introduction) > 1000) {
            warningTextListNew['self_introduction']['value'] = zhanden[languages].introduce.waring1;
        } else {
            warningTextListNew['self_introduction']['value'] = '';
        }
        // 现职
        if (current_occupation !== '' && getStringLenth(current_occupation) > 100) {
            warningTextListNew['current_occupation']['value'] = zhanden[languages].occupation.waring1;
        } else {
            warningTextListNew['current_occupation']['value'] = '';
        }
        // 目前所在城市
        if (current_city !== '' && getStringLenth(current_city) > 100) {
            warningTextListNew['current_city']['value'] = zhanden[languages].city.waring2;
        } else {
            warningTextListNew['current_city']['value'] = '';
        }

        // 还能再哪些平台了解你
        if (other_platforms !== '' && getStringLenth(other_platforms) > 300) {
            warningTextListNew['other_platforms']['value'] = zhanden[languages].about.waring1;
        } else {
            warningTextListNew['other_platforms']['value'] = '';
        }

        let flag = true;

        for (const key in warningTextListNew) {
            warningTextListNew[key]['isScrollTop'] = false;
        }

        for (let i = 0; i < dataOrder.length; i++) {
            if (warningTextList?.[dataOrder[i]]?.['value']) {
                warningTextListNew[dataOrder[i]]['isScrollTop'] = true;
                flag = false;
                break;
            } else {
                flag = true;
            }
        }

        if (!flag) {
            checkRequiredSucess = true;
        } else {
            checkRequiredSucess = false;
        }
        const stringifyData = JSON.stringify(warningTextListNew);
        const parseData = JSON.parse(stringifyData);

        setWarningTextList((data) => {
            return {
                ...data,
                ...parseData,
            };
        });
    };

    const setFormDataHandle = (key, value) => {
        const obj = {};

        obj[key] = value;
        setFormData((data) => {
            return {
                ...data,
                ...obj,
            };
        });
    };

    const understandHandle = (value) => {
        setUnderstand(value);
    };

    const confirmDataHandle = (value) => {
        if (value?.isClickOk === true) {
            setIsShowLoading(true);
        }
        
        setConfirmData(value);
    };

    // 校验表单所有操作
    const checkFormMenuHandle = () => {
        checkFormDataHandle();
        let isSubmitSucess = true;

        if (checkRequiredSucess) {
            isSubmitSucess = false;
            setIsClickSubmit(false);

            return false;
        }

        // 验证是否勾选知晓信息
        if (!understand) {
            Toast.show({
                content: zhanden[languages].api.waring2,
                maskClickable: false,
            });
            isSubmitSucess = false;
            setIsClickSubmit(false);

            return false;
        }

        // 验证是否点击确认提交
        if (!confirmData.isClickOk) {
            confirmDataHandle({
                isClickOk: false,
                isCheck: false,
                isClosePopup: false,
            });

            return false;
        }

        return isSubmitSucess;
    };

    const submitFailHandle = () => {
        setIsShowLoading(false);
        confirmDataHandle({
            isClickOk: false,
            isCheck: false,
            isClosePopup: true,
        });
    };

    const submitHandle = async () => {
        // 数据提交
        if (checkFormMenuHandle()) {
            setIsShowLoading(true);
            
            try {
                const submitResult = updateId ? await updateFormHandleHK2024(formData, updateId) : await submitFormHandleHK2024(formData);

                if (submitResult?.data?.data && submitResult?.data?.code === 0) {
                    setHasSucessPopup(true);
                    setlocal('_id', submitResult?.data?.data?.data?._id);
                } else {
                    Toast.show({
                        content: zhanden[languages].api.waring1,
                        maskClickable: false,
                    });
                    submitFailHandle();
                }
            } catch (e) {
                Toast.show({
                    content: zhanden[languages].api.waring1,
                    maskClickable: false,
                });
                submitFailHandle();
            }
            setIsShowLoading(false);
        } else {
            submitFailHandle();
        }
    };

    // 初始化更新表单
    const getHostHandle = async () => {
        setIsShowLoading(true);
        try {
            const hostData = await getHostHandleHK2024(updateId);

            if (hostData?.data?.data) {
                const { img1_url, img2_url, ...filterHostData } = hostData.data.data;

                setFormData({
                    ...filterHostData
                });
                setlocal('img1FormBase64Url', img1_url);
                setlocal('img2FormBase64Url', img2_url);
                setUpdateSuccess(true);
                setIsShowLoading(false);
            } else {
                setIsShowLoading(false);
            }
        } catch (e) {
            setIsShowLoading(false);
        }
    };

    // 点击模块框确认
    useEffect(() => {
        if (confirmData.isClickOk) {
            submitHandle();
        } else {
            setIsClickSubmit(false);
        }
    }, [confirmData]);

    // 点击提交确认
    useEffect(() => {
        if (isClickSubmit) {
            checkFormMenuHandle();
        }
    }, [isClickSubmit]);

    // 数据本地存储
    const saveFormDataHandle = () => {
        setlocal('formData', formData);
        Toast.show({
            content: zhanden[languages].save.title, 
            maskClickable: false,
        });
    };

    // 数据初始化
    useEffect(() => {
        const formData = getlocal('formData');

        // 更新数据初始化
        if (updateId) {
            getHostHandle();

            return false;
        }

        // 储存数据初始化
        if (formData) {
            setFormData({
                ...formData,
            });
        }
    }, []);

    const setLanguagesHandle = (value) => {
        setLanguages(value);
        setlocal('languages', value);
    };

    useEffect(() => {
        let isWaring = false;

        // warningTextList对象key中的值value是否为空
        Object.keys(warningTextList).forEach((key) => {
            if (warningTextList[key].value && !isWaring) {
                isWaring = true;
            }
        });

        if (isWaring) {
            checkFormDataHandle();
        }
        
        document.title = zhanden[languages].banner.title;
    }, [languages]);

    return (
        <div className={styles.layout}>
            <Banner languages={languages} setLanguagesHandle={setLanguagesHandle} />
            <Required
                languages={languages}
                formData={formData}
                setFormDataHandle={setFormDataHandle}
                warningTextList={warningTextList}
            />
            <Media
                languages={languages}
                formData={formData}
                setFormDataHandle={setFormDataHandle}
                warningTextList={warningTextList}
                updateId={updateId}
                updateSuccess={updateSuccess}
            />
            <Needlessly
                languages={languages}
                formData={formData}
                setFormDataHandle={setFormDataHandle}
                warningTextList={warningTextList}
                updateSuccess={updateSuccess}
            />
            <FormInfo
                languages={languages}
                understand={understand}
                understandHandle={understandHandle}
            />
            <FormSubmit
                languages={languages}
                clickSubmitHandle={setIsClickSubmit}
                saveFormDataHandle={saveFormDataHandle}
            />
            <Confirm
                languages={languages}
                confirmData={confirmData}
                confirmDataHandle={confirmDataHandle}
                updateId={updateId}
            />
            {hasSucessPopup && <Success languages={languages} updateId={updateId} />}
            {isShowLoading && (
                <div className={styles.loadingBox}>
                    <SpinLoading color="#CE6400" />
                </div>
            )}
            <SecondShare languages={languages} />
        </div>
    );
};

export default errorBoundary(Layout);
